import { SvgIcon, SvgIconProps } from '@mui/material';

export const SanityIcon = ({ fontSize }: Pick<SvgIconProps, 'fontSize'>) => {
  return (
    <SvgIcon fontSize={fontSize}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="192"
        height="192"
        viewBox="40 40 112 112"
        fill="none"
      >
        <path
          d="M146.306 108.9L142.197 101.77L122.32 113.84L144.397 85.8165L147.735 83.864L146.909 82.6271L148.425 80.6954L141.459 74.9142L138.27 78.9652L73.9066 116.508L97.7035 87.9775L142.027 63.7548L137.816 55.6389L113.674 68.8273L125.562 54.5827L118.752 48.6L91.9963 80.6746L65.4237 95.204L85.7678 68.3895L98.5159 61.7745L94.4674 53.5682L57.3267 72.8435L67.4547 59.4814L60.38 53.8322L39 82.0434L39.3317 82.3075L43.3261 90.4165L67.0282 78.1106L45.4248 106.579L48.9656 109.407L51.0711 113.465L76.0257 99.8248L48.5458 132.775L55.3566 138.758L56.7241 137.118L123.017 98.3239L101.007 126.271L101.366 126.57L101.332 126.591L105.895 134.505L135.169 116.724L123.897 134.86L131.452 139.8L149.4 110.929L146.306 108.9Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};
